export enum UploadEvent {
    Start = 'start',
    Completed = 'completed',
    Next = 'next',
}

export function isUploadEvent(value: any): value is UploadEvent {
    return ['start', 'completed', 'next'].includes(value);
}
